import './App.css';
import './navbar.css';
import './home.css';
import './studentlist.css';
import './stafflist.css';
import './stafflistadd.css';
import './login.css';
import './classteacheradd.css';
import './subjectsadd.css';
import './subjecteacheradd.css';
import './noticeadd.css';
import './holidayadd.css';
import "./addstudent.css";
import "./addclassandsection.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Login from "./Component/Login";
import SuperAdminLogin from './Component/superadminLogin';
import ProtectedRoutes from "./Component/ProtectedRoutes";
import PublicRoutes from "./Component/PublicRoutes";
import NavigationProvider from "./contentApi/navigationProvider";

// layouts
import Dashboardlayout from "./Component/admin/Dashboardlayout";

// pages
import DashboardHome from "./Component/admin/Home";

// student
import Studentlist from "./Component/admin/students";
import AddStudent from './Component/admin/addStudent';
import EditStudent from './Component/admin/editStudent';

// staff
import Stafflist from "./Component/admin/Stafflist";
import AddStaff from './Component/admin/addStaff';
import EditStaff from './Component/admin/editStaff';
import StaffDetails from './Component/admin/staffDetails';

// classteacher
import ClassTeacher from './Component/admin/ClassTeacher';
import AddClassTeacher from './Component/admin/addClassTeacher';
import EditClassTeacher from './Component/admin/editClassTeacher';

// subject
import Subjects from './Component/admin/Subject';
import AddSubject from './Component/admin/addSubject';
import EditSubject from './Component/admin/editSubject';

// subjectteacher
import SubjectTeacher from './Component/admin/subjectTeacher';
import AddSubjectTeacher from './Component/admin/addSubjectTeacher';

// classandsection
import ClassandSection from './Component/admin/ClassandSection';
import AddClassandSection from './Component/admin/addClassandSection';
import EditClassandSection from './Component/admin/editClassandSection';

// holiday
import Holiday from './Component/admin/holiday';
import AddHoliday from './Component/admin/addHoliday';
import EditHoliday from './Component/admin/editHoliday';

import Notices from './Component/admin/notices';
import AddNotice from './Component/admin/addNotice';
import EditNotice from './Component/admin/editNotice';
import FeesList from './Component/admin/fees';
import AddFees from './Component/admin/addfees';
import EditFees from './Component/admin/editfees';

import Homework from './Component/admin/homework';
import AddHomework from './Component/teacher/addHomework';
import EditHomework from './Component/teacher/editHomework';
import DiaryNote from './Component/admin/DiaryNote';
import AddClassSubject from './Component/admin/addClassSubject';
import Attendance from './Component/teacher/Attendance';
import AddAttendance from './Component/teacher/addAttendance';
import AdminAttendance from './Component/admin/attendence';
import ClassSubject from './Component/admin/classSubject';
import AddFeeType from './Component/admin/addFeeType';
import AdminNotes from './Component/admin/notes';
import Activity from './Component/admin/Activity';
import FeeReport from './Component/admin/feereport';


//teacher------------- >
import TeacherDashboardlayout from './Component/teacher/teacherDashboardlayout';
import TeacherProfile from './Component/teacher/teacherProfile';
import TeacherHome from './Component/teacher/teacherHome';
import TeacherNotices from './Component/teacher/teacherNotice';
import TeacherDiaryNote from './Component/teacher/teacherDiaryNote';
import TeacherActivity from './Component/teacher/teacherActivity';
import AddActivity from './Component/teacher/addActivity';
import AddDiaryNote from './Component/teacher/addDiaryNote';
import EditDiaryNote from './Component/teacher/editDiaryNote';

import StudentDashboardlayout from './Component/student/studentDashboardlayout';
import StudentHome from "./Component/student/studentHome";
import StudentHoliday from "./Component/student/holiday";
import StudentProfile from './Component/student/studentProfile';
import StudentHomework from './Component/student/studentHomework';
import StudentAttendence from './Component/student/studentAttendence';
import StudentNotices from './Component/student/notices';
import StudentFees from './Component/student/studentFees';
import StudentNotes from './Component/student/studentNotes';
import StudentDiaryNote from './Component/student/studentDiarynote';
import StudentActivity from './Component/student/studentActivity';
import EditClassSubject from './Component/admin/editClassSubject';
import Reportcard from './Component/teacher/Reportcard';
import TeacherReportResult from './Component/teacher/teacherReportResult';
import Timetable from './Component/teacher/Timetable';
import TeacherNotes from './Component/teacher/teacherNotes';
import AddNotes from './Component/teacher/addNotes';
import EditNotes from './Component/teacher/editNotes';
import TeacherHomework from './Component/teacher/teacherHomework';
import TeacherHoliday from './Component/teacher/holiday';


//super admin
import SAdminDashboardlayout from './Component/superadmin/SAdminDashboardlayout';
import SAdminHome from './Component/superadmin/Home';
import AddInstitution from './Component/superadmin/addInstitute';
import Institute from './Component/superadmin/institute';
import FeeType from './Component/admin/feeType';
import FeeStructure from './Component/admin/feeStructure';
import AddFeeStructure from './Component/admin/addFeeStructure';
import EditFeeStructure from './Component/admin/editFeeStructure';
import AccountsDashboardlayout from './Component/accounts/AccountsDashboardlayout';
import AccountsHome from './Component/accounts/AccountsHome';
import SetMarks from './Component/admin/setMarks';
import AddSetMarks from './Component/admin/addSetMarks';
import EditSetMarks from './Component/admin/editSetMarks';
import OpeningBalance from './Component/accounts/openingBalance';
import FeesCollection from './Component/accounts/feesCollection';
import TransportFeesCollection from './Component/accounts/transportFeeCollection';
import Report from './Component/accounts/report';
import Expense from './Component/accounts/expense';
import AddExpense from './Component/accounts/addExpense';
import Result from './Component/admin/result';
import ExamSubject from './Component/admin/examSubject';
import AddExamSubject from './Component/admin/addExamSubject';
import EditExamSubject from './Component/admin/editExamSubject';
import StudentId from './Component/admin/studentId';
import StaffId from './Component/admin/staffId';




function App() {
  return (
    <NavigationProvider>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<PublicRoutes />}>
          <Route index element={<Login />} />
          <Route path="login" element={<Login />} />
          <Route path="admin-login" element={<SuperAdminLogin />} />
        </Route>

        <Route path="/institute" element={<ProtectedRoutes />}>
          <Route element={<Dashboardlayout />}>
            <Route index element={<DashboardHome />} />
            <Route path="home" element={<DashboardHome />} />
            <Route path="students" element={<Studentlist />} />
            <Route path="add-student" element={<AddStudent />} />
            <Route path="edit-student/:id" element={<EditStudent />} />
            <Route path="staffs" element={<Stafflist />} />
            <Route path="add-staff" element={<AddStaff />} />
            <Route path="edit-staff/:id" element={<EditStaff />} />
            <Route path="staff-details/:id" element={<StaffDetails />} />
            <Route path="subjects" element={<Subjects />} />
            <Route path="add-subject" element={<AddSubject />} />
            <Route path="edit-subject/:id" element={<EditSubject />} />
            <Route path="add-subject-teacher" element={<AddSubjectTeacher />} />
            <Route path="subjectteachers" element={<SubjectTeacher />} />
            <Route path="add-classandsection" element={<AddClassandSection />} />
            <Route path="classandsection" element={<ClassandSection />} />
            <Route path="edit-classandsection/:id" element={<EditClassandSection />} />
            <Route path="classteachers" element={<ClassTeacher />} />
            <Route path="add-class-teacher" element={<AddClassTeacher />} />
            <Route path="edit-classteacher/:id" element={<EditClassTeacher />} />
            <Route path="add-class-subject" element={<AddClassSubject />} />
            <Route path="edit-class-subject/:id" element={<EditClassSubject />} />

            <Route path="add-exam-subject" element={<AddExamSubject />} />
            <Route path="edit-exam-subject/:id" element={<EditExamSubject />} />

            <Route path="notices" element={<Notices />} />
            <Route path="add-notice" element={<AddNotice />} />
            <Route path="edit-notice/:id" element={<EditNotice />} />
            <Route path="add-fee-type" element={<AddFeeType />} />
            <Route path="fee-type" element={<FeeType />} />
            <Route path="fee-structure" element={<FeeStructure />} />
            <Route path="add-fee-structure" element={<AddFeeStructure />} />
            <Route path="edit-fee-structure/:id" element={<EditFeeStructure />} />
            <Route path="holidays" element={<Holiday />} />
            <Route path="add-holiday" element={<AddHoliday />} />
            <Route path="edit-holiday/:id" element={<EditHoliday />} />
            <Route path="fees" element={<FeesList />} />
            <Route path="add-fees" element={<AddFees />} />
            <Route path="edit-fees/:id" element={<EditFees />} />
            <Route path="homework" element={<Homework />} />
            <Route path="diarynote" element={<DiaryNote />} />
            <Route path="attendance" element={<AdminAttendance />} />
            <Route path="notes" element={<AdminNotes />} />
            <Route path="classsubjects" element={<ClassSubject />} />
            <Route path="examsubjects" element={<ExamSubject />} />
            <Route path="activity" element={<Activity />} />
            <Route path="set-marks" element={<SetMarks />} />
            <Route path="add-set-marks" element={<AddSetMarks />} />
            <Route path="edit-set-marks/:id" element={<EditSetMarks />} />
            <Route path="fees-report" element={<FeeReport />} />
            <Route path="result" element={<Result />} />
            <Route path="student-id" element={<StudentId />} />
            <Route path="staff-id" element={<StaffId />} />
          </Route >
        </Route >


        < Route path="/teacher" element={< ProtectedRoutes />}>
          <Route element={<TeacherDashboardlayout />}>
            <Route index element={<TeacherHome />} />
            <Route path="home" element={<TeacherHome />} />
            <Route path="homework" element={<TeacherHomework />} />
            <Route path="add-homework" element={<AddHomework />} />
            <Route path="edit-homework/:id" element={<EditHomework />} />
            <Route path="reportcard" element={<Reportcard />} />
            <Route path="reportresult" element={<TeacherReportResult />} />
            <Route path="notes" element={<TeacherNotes />} />
            <Route path="add-notes" element={<AddNotes />} />
            <Route path="edit-notes/:id" element={<EditNotes />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="add-attendance" element={<AddAttendance />} />
            <Route path="activity" element={<TeacherActivity />} />
            <Route path="add-activity" element={<AddActivity />} />
            <Route path="diarynote" element={<TeacherDiaryNote />} />
            <Route path="add-diarynote" element={<AddDiaryNote />} />
            <Route path="edit-diarynote/:id" element={<EditDiaryNote />} />
            <Route path="holidays" element={<TeacherHoliday />} />
            <Route path="notices" element={<TeacherNotices />} />
            <Route path="timetable" element={<Timetable />} />
            <Route path="teacherprofile" element={<TeacherProfile />} />
          </Route >
        </Route >


        < Route path="/student" element={< ProtectedRoutes />}>
          <Route element={<StudentDashboardlayout />}>
            <Route index element={<StudentHome />} />
            <Route path="home" element={<StudentHome />} />
            <Route path="profile" element={<StudentProfile />} />
            <Route path="homework" element={<StudentHomework />} />
            <Route path="attendence" element={<StudentAttendence />} />
            <Route path="holidays" element={<StudentHoliday />} />
            <Route path="notice" element={<StudentNotices />} />
            <Route path="fees" element={<StudentFees />} />
            <Route path="notes" element={<StudentNotes />} />
            <Route path="diarynote" element={<StudentDiaryNote />} />
            <Route path="activity" element={<StudentActivity />} />
          </Route >
        </Route >

        < Route path="/accounts" element={< ProtectedRoutes />}>
          <Route element={<AccountsDashboardlayout />}>
            <Route index element={<AccountsHome />} />
            <Route path="home" element={<AccountsHome />} />
            <Route path="opening-balance" element={<OpeningBalance />} />
            <Route path="fees-collection" element={<FeesCollection />} />
            <Route path="transport-fees-collection" element={<TransportFeesCollection />} />
            <Route path="reports" element={<Report />} />
            <Route path="expense" element={<Expense />} />
            <Route path="add-expense" element={<AddExpense />} />
          </Route >
        </Route >


        < Route path="/sadmin" element={< ProtectedRoutes />}>
          <Route element={<SAdminDashboardlayout />}>
            <Route index element={<SAdminHome />} />
            <Route path="home" element={<SAdminHome />} />
            <Route path="add-institute" element={<AddInstitution />} />
            <Route path="institute" element={<Institute />} />
          </Route>
        </Route >
      </Routes >
    </NavigationProvider >
  );
}

export default App;
